import React, {useEffect, useState} from "react";

const RandomNumber = ({className}) => {
    const [random, setRandom] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setRandom(Math.floor(Math.random() * 10));
        }, 90);

        return () => clearInterval(interval);
    }, []);

    return <span className={className}>{random}</span>;
};

const Random = ({sizeDigit, ...rest}) => {
    return (
        <>
            {Array.from({length: sizeDigit}).map((_, i) => (
                <RandomNumber key={i} {...rest} />
            ))}
        </>
    );
};

export default Random;
